import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureCards from './components/FeatureCards';
import AboutSection from './components/AboutSection';
import ArticlePreview from './components/ArticlePreview';
import BlogSection from './components/BlogSection';
import TrustSection from './components/TrustSection';
import CTASection from './components/CTASection';

const siteUrl =
  typeof __VITE_SITE_URL__ !== 'undefined' && __VITE_SITE_URL__
    ? __VITE_SITE_URL__.replace(/\/+$/, '')
    : 'https://mulebuyspreadsheets.motorcycles';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEO
        title="Mulebuy Spreadsheet Database – The Most Complete Mulebuy Spreadsheet Resource Online"
        description="Discover, compare, and explore the most updated Mulebuy Spreadsheet lists, guides, and product sourcing data. Your ultimate resource for mulebuy spreadsheet guides, best mulebuy spreadsheet comparisons, and complete database access."
        keywords="mulebuy spreadsheet, mulebuy spreadsheet list, best mulebuy spreadsheet, mulebuy spreadsheet guide, mulebuy spreadsheet database"
        canonicalPath="/"
        ogType="website"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Mulebuy Spreadsheet Database',
          url: siteUrl,
          description: 'Discover, compare, and explore the most updated Mulebuy Spreadsheet lists, guides, and product sourcing data.',
          potentialAction: {
            '@type': 'SearchAction',
            target: `${siteUrl}/?search={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureCards />
        <AboutSection />
        <ArticlePreview />
        <BlogSection />
        <TrustSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}